import request from '@/utils/request'

// export function getBannerPage (val) {
//   return request({
//     url: `/api/pms/admin/banner/list/${val.params.page}/${val.params.size}`,
//     method: 'get',
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded'
//     },
//     params: val.vo
//   })
// }

export function getBannerPage (val) {
  return request({
    url: `/api/pms/banner/list/${val.params.page}/${val.params.size}`,
    method: 'post',
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // },
    data: val.vo
  })
}

export function addBanner (val) {
  return request({
    url: '/api/pms/admin/banner/add',
    method: 'post',
    data: val
  })
}

export function updateBanner (val) {
  return request({
    // url: '/api/pms/admin/banner/update/' + val.id,
    url: '/api/pms/open/banner/update/' + val.id,
    method: 'put',
    data: val
  })
}

export function delBanner (val) {
  return request({
    url: '/api/pms/admin/banner/delete/' + val,
    method: 'delete'
  })
}

export function getBannerDetail (val) {
  return request({
    // url: '/api/pms/admin/banner/' + val,
    url: '/api/pms/banner/' + val,
    method: 'get'
  })
}
